export const SET_PRICE = 'SET_PRICE';
export const SET_FINAL_PRICE = 'SET_FINAL_PRICE';